import { jwtDecode } from 'jwt-decode';
import {
  dataStorageKeywords,
  DAY_IN_MILLISECONDS,
  errorMessages,
} from './properties.utils';
import Cookies from 'js-cookie';
import { getHighestPriorityRole } from './roles.utils';
import { setEncryptedLocalStorageData } from './dataStorageManagement.utils';
import { calculateTimeToExpire } from './text.utils';

export interface DecodedAccessToken {
  userId: string;
  companyId: string;
  roles: string[];
  exp: number;
}

export interface DecodedRefreshToken {
  userId: string;
  companyId: string;
  exp: number;
}

export const decodeAccessToken = (token: string): DecodedAccessToken => {
  try {
    const decoded: DecodedAccessToken = jwtDecode(token);
    return decoded;
  } catch (error) {
    throw new Error(errorMessages.SESSION_EXPIRED);
  }
};

export const decodeRefreshToken = (token: string): DecodedRefreshToken => {
  try {
    const decoded: DecodedRefreshToken = jwtDecode(token);
    return decoded;
  } catch (error) {
    throw new Error(errorMessages.SESSION_REFRESH_FAILED);
  }
};

export const handleLoginDataStorage = (
  tokens: any,
  roles: any[],
  fullName: string
) => {
  const decodedAccessToken = decodeAccessToken(tokens.accessToken);
  const decodedRefreshToken = decodeRefreshToken(tokens.refreshToken);
  const companyId = decodedAccessToken.companyId;
  const userId = decodedAccessToken.userId;

  const accesstokenExpiration = decodedAccessToken.exp;
  const refreshtokenExpiration = decodedRefreshToken.exp;

  const accessTimeToExpire = calculateTimeToExpire(accesstokenExpiration);
  const refreshTimeToExpire = calculateTimeToExpire(refreshtokenExpiration);
  const cookiesTimeToExpire = accessTimeToExpire + refreshTimeToExpire;

  Cookies.set(dataStorageKeywords.ACCESS_TOKEN, tokens.accessToken, {
    expires: accessTimeToExpire / DAY_IN_MILLISECONDS,
  });
  Cookies.set(dataStorageKeywords.REFRESH_TOKEN, tokens.refreshToken, {
    expires: refreshTimeToExpire / DAY_IN_MILLISECONDS,
  });
  Cookies.set(dataStorageKeywords.USER_ID, userId, {
    expires: cookiesTimeToExpire / DAY_IN_MILLISECONDS,
  });
  Cookies.set(dataStorageKeywords.COMPANY_ID, companyId, {
    expires: cookiesTimeToExpire / DAY_IN_MILLISECONDS,
  });

  const highestRole = getHighestPriorityRole(roles);

  setEncryptedLocalStorageData(dataStorageKeywords.FULL_NAME, fullName);
  setEncryptedLocalStorageData(
    dataStorageKeywords.ROLES,
    JSON.stringify(roles)
  );
  setEncryptedLocalStorageData(dataStorageKeywords.HIGHEST_ROLE, highestRole);
  setEncryptedLocalStorageData(dataStorageKeywords.IS_LOGGED_IN, 'true');
};

export const handleLocalStorageData = (roles: any[]) => {
  const highestRole = getHighestPriorityRole(roles);

  setEncryptedLocalStorageData(
    dataStorageKeywords.ROLES,
    JSON.stringify(roles)
  );
  setEncryptedLocalStorageData(dataStorageKeywords.HIGHEST_ROLE, highestRole);
};
